import { Typography } from '@material-ui/core';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles as styles } from './style/gstheme';

class ComponentHint extends React.Component {

    render() {

        const { text } = this.props;

        return (
            <div data-test="hint-1" style={{ margin: '6px 12px', backgroundColor: 'rgb(2, 128, 144, 0.1)', padding: '0px 12px 6px 12px', boxShadow: '0px 3px 6px #00000029', borderRadius: 4, border: 'solid 1px #f0f0f0', width: 180 }}>
                <Typography variant="caption">Click on the {text} title <ArrowUpwardIcon style={{ transform: 'translate(0px, 6px)' }} /> or the settings icon to manage the {text}.</Typography>
            </div>

        );
    }
}

ComponentHint.propTypes = {
    text: PropTypes.string.isRequired,
    classes: PropTypes.object
};

export default withStyles(styles)(ComponentHint);